var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

import { BooleanEdit } from './boolean';

import { ValueEditor } from 'sdc-react-editors';

import { fieldValue } from 'sdc-data-models';

var EditingControls = function EditingControls(_ref) {
  var store = _ref.store,
      editStyle = _ref.editStyle,
      labelStyle = _ref.labelStyle,
      viewStyle = _ref.viewStyle,
      props = _objectWithoutProperties(_ref, ['store', 'editStyle', 'labelStyle', 'viewStyle']);

  switch (props.field.dataType) {
    case 'boolean':
      return React.createElement(BooleanEdit, _extends({}, props, { style: editStyle }));
    case 'integer':
    case 'float':
    case 'percent':
      return React.createElement(ValueEditor, _extends({}, props, { style: editStyle, value: fieldValue(store.selected, props.field.key), onSelect: store.selectField, onUpdate: store.updateField }));
    default:
      return null;
  }
};
export { EditingControls };